export default __webpack_public_path__ + "static/media/01.c68d901d.jpg";